export default [
    {
        title: "The Independent Freelancer",
        text: "The thing with an independent freelancer is that they are unreliable. You need a team who is dedicated to you and your needs, not someone who works separately."
    },
    {
        title: "Lack of Responsiveness",
        text: "Sometimes, it’s hard to get people on the phone. You need a group who is grounded and passionate about web development and design. With other big companies managing multiple firms, your project can feel like its taking a backseat."
    },
    {
        title: "Inconsistency",
        text: "With other companies and independent freelancers, it is more difficult to trust that your store will be done on time and to your satisfaction. This can be a huge headache and one that can be avoided. With something so important, why settle?"
    },
]